module.exports = __webpack_public_path__ + "img/login_bg.fcee6c42.jpg";